// extracted by mini-css-extract-plugin
module.exports = {"authentication-method":"AuthenticationMethod_authentication-method__1YHnS"};